export default "__VITE_ASSET__aee96c8c__"